<div class="iq-navbar-header acc-page-header-main">
  <div class="row">
    <div class="col-md-12">
      <div class="flex-wrap d-flex justify-content-between align-items-center acc-page-header-content">
        <span class="text">
          <ng-content/>
        </span>
      </div>
    </div>
  </div>
</div>
